namespace TabAurous.Finance {
    export interface PeriodicClosingForm {
        VoucherTypeId: Serenity.IntegerEditor;
        TransDate: Serenity.DateEditor;
        PostingDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        FinancialYear: Serenity.LookupEditor;
        CompanyId: Serenity.LookupEditor;
        SurplusAccountId: Serenity.LookupEditor;
    }

    export class PeriodicClosingForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.PeriodicClosing';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PeriodicClosingForm.init)  {
                PeriodicClosingForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;

                Q.initFormType(PeriodicClosingForm, [
                    'VoucherTypeId', w0,
                    'TransDate', w1,
                    'PostingDate', w1,
                    'VoucherNo', w2,
                    'FinancialYear', w3,
                    'CompanyId', w3,
                    'SurplusAccountId', w3
                ]);
            }
        }
    }
}
